import { render, staticRenderFns } from "./CostsBase.vue?vue&type=template&id=3e685c16&scoped=true&"
import script from "./CostsBase.vue?vue&type=script&lang=js&"
export * from "./CostsBase.vue?vue&type=script&lang=js&"
import style0 from "./CostsBase.vue?vue&type=style&index=0&id=3e685c16&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e685c16",
  null
  
)

export default component.exports